// @ts-nocheck
import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementAddress', 'WebformElementWebformAddress'],
  (item, ctx) => {
    return {
      $el: 'div',
      children: ctx.buildChildren(item.element.items),
    }
  },
)
